import { useEffect, useState } from "react"
// import { API, graphqlOperation } from "aws-amplify"
import moment from "moment"
import { getDistance } from "geolib"
import { listExperiences } from "../graphql/queries"

// function filterByLocation(
//   experiences: Experience[],
//   radius: number,
//   searchedLocation: { lat: number; lng: number }
// ) {
//   const { lat, lng } = searchedLocation
//   return experiences.filter((exp) => {
//     let isInRadius = false
//     exp.coordinates.forEach(({ latitude, longitude }) => {
//       if (!isInRadius) {
//         isInRadius =
//           getDistance(
//             { latitude: lat, longitude: lng },
//             { latitude: parseFloat(latitude), longitude: parseFloat(longitude) }
//           ) /
//             1000 <=
//           radius
//       }
//     })
//     return isInRadius
//   })
// }

// function filterByNumberOfPeople(
//   experiences: Experience[],
//   numberOfPeople: number
// ) {
//   if (numberOfPeople === "Tous") {
//     numberOfPeople = 1000
//   }
//   return experiences.filter(
//     (exp: Experience) => exp.participantsQuotasInfo.max <= numberOfPeople
//   )
// }

// function filterByCategories(experiences: Experience[], categories: [string]) {
//   return experiences.filter((exp) => {
//     for (const cat of exp.categories) {
//       if (categories.includes(cat)) {
//         return true
//       }
//     }
//     return false
//   })
// }

// function filterByDate(
//   experiences: Experience[],
//   dateRange: { startDate: Date; endDate: Date }
// ) {
//   const { startDate, endDate } = dateRange
//   return experiences.filter((exp) => {
//     for (const session of exp.sessions) {
//       if (session.dates.length === 0) {
//         return true
//       }
//       for (const date of session.dates) {
//         const momentedDate = date.split("/").reverse().join("/")
//         if (moment(momentedDate).isBetween(startDate, endDate, null, "[]")) {
//           return true
//         }
//       }
//     }
//     return false
//   })
// }

// async function getExperiencesByCategory(
//   setExperiences: (experiences: EventInfo[]) => void,
//   setLoading: (isLoading: boolean) => void,
//   selectedCategories: [string],
//   searchedLocation: { lat: number; lng: number },
//   budget: number,
//   dateRange: { startDate: Date; endDate: Date },
//   numberOfPeople: number
// ) {
//   const options = {
//     limit: 1000,
//   }
//   if (budget) {
//     options.filter = { ...options.filter, ...{ price: { lt: budget } } }
//   }

//   const response = await API.graphql(graphqlOperation(listExperiences, options))

//   let { items } = response.data.listExperiences
//   if (searchedLocation.lat) {
//     items = filterByLocation(items, 30, searchedLocation)
//   }
//   if (numberOfPeople) {
//     items = filterByNumberOfPeople(items, numberOfPeople)
//   }
//   if (selectedCategories.length > 0) {
//     items = filterByCategories(items, selectedCategories)
//   }
//   if (dateRange && dateRange.startDate && dateRange.endDate) {
//     items = filterByDate(items, dateRange)
//   }
//   setExperiences(items)
//   setLoading(false)
// }

export default function useGetExperiencesByCategory(
  setLoading: (isLoading: boolean) => void,
  selectedCategories: [string],
  searchedLocation: { lat: number; lng: number },
  budget: number,
  numberOfPeople: number,
  dateRange: { startDate: Date; endDate: Date },
  loading: boolean
) {
  const [experiences, setExperiences] = useState<EventInfo[]>([])
  useEffect(() => {
    // if (loading) {
    //   getExperiencesByCategory(
    //     setExperiences,
    //     setLoading,
    //     selectedCategories,
    //     searchedLocation,
    //     budget,
    //     dateRange,
    //     numberOfPeople
    //   )
    // }
  }, [loading])

  return experiences
}
